"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Language = void 0;
var LanguageStore_1 = __importDefault(require("./Store/LanguageStore"));
var Language = /** @class */ (function () {
    function Language(session) {
        this.languageStore = new LanguageStore_1.default(session);
    }
    Language.prototype.getAll = function () {
        return this.languageStore.getAll();
    };
    return Language;
}());
exports.Language = Language;
//# sourceMappingURL=Language.js.map